import DocumentListItem from './ResponsiveDocumentListItem';

export default DocumentListItem;
